module.exports = __webpack_public_path__ + "img/zoom.c5a26e71.gif";